import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import MapMarkerIcon from '../icons/MapMarkerIcon';

const MAPBOX_API_TOKEN =
  'pk.eyJ1IjoibW9ibGVlIiwiYSI6ImNqazE5bmYxbzBmYjczd29naDN2M3J4bjkifQ.u7zc5Rrqs1xqBv6V2CWfAg';

const getMap = async props => {
  const { default: ReactMapboxGl, Marker } = await import('react-mapbox-gl');
  const { classes, latitude, longitude } = props;

  const Map = ReactMapboxGl({
    minZoom: 14,
    maxZoom: 18,
    accessToken: MAPBOX_API_TOKEN,
  });

  return (
    <Map
      // eslint-disable-next-line react/style-prop-object
      style="mapbox://styles/mapbox/streets-v9"
      containerStyle={{
        height: '100%',
        width: '100%',
      }}
      center={[longitude, latitude]}
      zoom={[16]}
    >
      <Marker coordinates={[longitude, latitude]}>
        <MapMarkerIcon className={classes.marker} />
      </Marker>
    </Map>
  );
};

class MapBox extends PureComponent {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    latitude: PropTypes.number.isRequired,
    longitude: PropTypes.number.isRequired,
  };

  state = {};

  buildMap = async () => {
    const Map = await getMap(this.props);
    this.setState({ Map });
  };

  componentDidMount() {
    this.buildMap();
  }

  render() {
    const { Map } = this.state;

    if (Map) {
      return Map;
    }

    return null;
  }
}

const stylesheet = theme => ({
  marker: {
    width: 6 * theme.spacing.unit,
    height: 6 * theme.spacing.unit,
  },
});

export default injectSheet(stylesheet)(MapBox);



// WEBPACK FOOTER //
// ./src/site-render/src/LocationSection/MapBox.js